import React, { ReactElement } from 'react';
import clsx from 'classnames';
import s from './Divider.module.scss';

const Divider = ({ dashed, className }: { dashed?: boolean; className?: string }): ReactElement => (
  <hr className={clsx([s.divider, dashed && s.dashed, className])} />
);

export default Divider;
